import React from 'react';
import { Link } from 'react-router-dom';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'small' | 'medium' | 'large';
  to?: string;
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  to,
  href,
  onClick,
  disabled = false,
  className = '',
  children,
  type = 'button'
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-body font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-purple disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantClasses = {
    primary: 'bg-accent-gradient text-white hover:shadow-lg hover:scale-105 focus:shadow-button-focus',
    secondary: 'bg-white text-brand-purple border border-brand-purple hover:bg-primary-50',
    tertiary: 'text-brand-purple hover:text-brand-blue'
  };
  
  const sizeClasses = {
    small: 'px-4 py-2 text-label rounded-md',
    medium: 'px-6 py-2.5 text-button rounded-lg',
    large: 'px-8 py-4 text-button-lg rounded-lg'
  };
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  
  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }
  
  if (href) {
    return (
      <a href={href} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {children}
    </button>
  );
};

export default Button;
